import React from "react";

// Base SVG wrapper — hereda color del contexto vía currentColor.
// display:inline-block + verticalAlign:middle hace que el icono quede
// SIEMPRE junto al texto (botones anchos y bajos, no apilados).
const S = ({ size = 18, children, style, className }) => (
  <svg
    width={size} height={size} viewBox="0 0 24 24"
    fill="none" stroke="currentColor"
    strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
    aria-hidden="true"
    style={{ flexShrink: 0, display: "inline-block", verticalAlign: "middle", ...style }}
    className={className}
  >
    {children}
  </svg>
);

// ── Navegación / UI ───────────────────────────────────────────────────────────

// fas fa-bars
export const IcMenu = (p) => (
  <S {...p}>
    <line x1="3" y1="6"  x2="21" y2="6"/>
    <line x1="3" y1="12" x2="15" y2="12"/>
    <line x1="3" y1="18" x2="18" y2="18"/>
  </S>
);

export const IcChevL = (p) => <S {...p}><polyline points="15 18 9 12 15 6"/></S>;
export const IcChevR = (p) => <S {...p}><polyline points="9 18 15 12 9 6"/></S>;
export const IcChevD = (p) => <S size={13} {...p}><polyline points="6 9 12 15 18 9"/></S>;
export const IcChevU = (p) => <S size={13} {...p}><polyline points="18 15 12 9 6 15"/></S>;

// fas fa-sort
export const IcSort = (p) => (
  <S {...p}>
    <line x1="16" y1="3"  x2="16" y2="21"/>
    <polyline points="12 7 16 3 20 7"/>
    <line x1="8"  y1="21" x2="8"  y2="3"/>
    <polyline points="4 17 8 21 12 17"/>
  </S>
);

// fas fa-search
export const IcSearch = (p) => (
  <S {...p}>
    <circle cx="11" cy="11" r="8"/>
    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </S>
);

// fas fa-times
export const IcX = (p) => (
  <S {...p}>
    <line x1="18" y1="6"  x2="6"  y2="18"/>
    <line x1="6"  y1="6"  x2="18" y2="18"/>
  </S>
);

// fas fa-plus
export const IcPlus = (p) => (
  <S {...p}>
    <line x1="12" y1="5" x2="12" y2="19"/>
    <line x1="5" y1="12" x2="19" y2="12"/>
  </S>
);

// fas fa-minus
export const IcMinus = (p) => <S {...p}><line x1="5" y1="12" x2="19" y2="12"/></S>;

// fas fa-plus-circle
export const IcPlusCircle = (p) => (
  <S {...p}>
    <circle cx="12" cy="12" r="9.5"/>
    <line x1="12" y1="8" x2="12" y2="16"/>
    <line x1="8"  y1="12" x2="16" y2="12"/>
  </S>
);

// fas fa-ban
export const IcBan = (p) => (
  <S {...p}>
    <circle cx="12" cy="12" r="9.5"/>
    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
  </S>
);

// fas fa-spinner (sin animación — añadir className="spin" si se necesita)
export const IcSpinner = (p) => (
  <S {...p}>
    <path d="M21 12a9 9 0 1 1-6.22-8.56" strokeOpacity={0.9}/>
  </S>
);

// fas fa-sync-alt
export const IcSync = (p) => (
  <S {...p}>
    <polyline points="23 4 23 10 17 10"/>
    <polyline points="1 20 1 14 7 14"/>
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
  </S>
);

// fas fa-repeat
export const IcRepeat = (p) => (
  <S {...p}>
    <polyline points="17 1 21 5 17 9"/>
    <path d="M3 11V9a4 4 0 0 1 4-4h14"/>
    <polyline points="7 23 3 19 7 15"/>
    <path d="M21 13v2a4 4 0 0 1-4 4H3"/>
  </S>
);

// fas fa-exchange-alt
export const IcExchange = (p) => (
  <S {...p}>
    <line x1="3" y1="7"  x2="21" y2="7"/>
    <polyline points="17 3 21 7 17 11"/>
    <line x1="21" y1="17" x2="3" y2="17"/>
    <polyline points="7 21 3 17 7 13"/>
  </S>
);

// ── Flechas ───────────────────────────────────────────────────────────────────

export const IcArrowUp = (p) => (
  <S {...p}>
    <line x1="12" y1="20" x2="12" y2="4"/>
    <polyline points="8 8 12 4 16 8"/>
  </S>
);
export const IcArrowDown = (p) => (
  <S {...p}>
    <line x1="12" y1="4" x2="12" y2="20"/>
    <polyline points="8 16 12 20 16 16"/>
  </S>
);
export const IcArrowLeft = (p) => (
  <S {...p}>
    <line x1="20" y1="12" x2="4" y2="12"/>
    <polyline points="10 18 4 12 10 6"/>
  </S>
);
export const IcArrowRight = (p) => (
  <S {...p}>
    <line x1="4" y1="12" x2="20" y2="12"/>
    <polyline points="14 18 20 12 14 6"/>
  </S>
);

// ── Documentos / Archivos ─────────────────────────────────────────────────────

// fas fa-file-alt
export const IcFileAlt = (p) => (
  <S {...p}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="8" y1="13" x2="16" y2="13"/>
    <line x1="8" y1="17" x2="13" y2="17"/>
  </S>
);

// fas fa-file-invoice
export const IcFileInvoice = (p) => (
  <S {...p}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="8" y1="12" x2="16" y2="12"/>
    <line x1="8" y1="16" x2="16" y2="16"/>
    <line x1="8" y1="20" x2="12" y2="20"/>
  </S>
);

// fas fa-file-invoice-dollar — documento con doblez + signo $
export const IcFileInvoiceDollar = (p) => (
  <S {...p}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="12" y1="10" x2="12" y2="18"/>
    <path d="M14.5 12.5c0-1.4-1.1-2.5-2.5-2.5-1.1 0-2.5.7-2.5 2 0 1.3 1.4 2 2.5 2s2.5.7 2.5 2c0 1.3-1.4 2-2.5 2-1.4 0-2.5-1.1-2.5-2.5"/>
  </S>
);

// far fa-file-pdf — documento con "PDF" implícito (líneas en zigzag)
export const IcPdf = (p) => (
  <S {...p}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <path d="M8 13h2a1.5 1.5 0 0 1 0 3H8v-3z"/>
    <line x1="8" y1="16" x2="8" y2="19"/>
    <path d="M13 13h2a2 2 0 0 1 0 4h-2v-4z"/>
    <line x1="18" y1="13" x2="18" y2="19"/>
    <line x1="18" y1="16" x2="20" y2="16"/>
  </S>
);

// far fa-file-excel — documento con X interior (estilo Excel)
export const IcExcel = (p) => (
  <S {...p}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="9"  y1="13" x2="15" y2="19"/>
    <line x1="15" y1="13" x2="9"  y2="19"/>
  </S>
);

// fas fa-save — disquete
export const IcSave = (p) => (
  <S {...p}>
    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
    <polyline points="17 21 17 13 7 13 7 21"/>
    <polyline points="7 3 7 8 15 8"/>
  </S>
);

// fas fa-table — cuadrícula
export const IcTable = (p) => (
  <S {...p}>
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <line x1="3"  y1="9"  x2="21" y2="9"/>
    <line x1="3"  y1="15" x2="21" y2="15"/>
    <line x1="9"  y1="3"  x2="9"  y2="21"/>
    <line x1="15" y1="3"  x2="15" y2="21"/>
  </S>
);

// fas fa-edit / far fa-edit — lápiz sobre papel
export const IcEdit = (p) => (
  <S {...p}>
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
    <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </S>
);

// fas fa-trash-alt — papelera
export const IcTrash = (p) => (
  <S {...p}>
    <polyline points="3 6 5 6 21 6"/>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
    <line x1="10" y1="11" x2="10" y2="17"/>
    <line x1="14" y1="11" x2="14" y2="17"/>
  </S>
);

// ── Usuarios ──────────────────────────────────────────────────────────────────

// fas fa-users — persona principal + segunda detrás (tenue)
export const IcUsers = (p) => (
  <S {...p}>
    <circle cx="9" cy="7" r="3.5"/>
    <path d="M2 21v-1a7 7 0 0 1 7-7h0a7 7 0 0 1 7 7v1"/>
    <circle cx="18" cy="8" r="2.5" strokeOpacity={0.5}/>
    <path d="M15.5 14.5A5.5 5.5 0 0 1 21.5 20V21" strokeOpacity={0.5}/>
  </S>
);

// fas fa-user-circle — avatar con círculo
export const IcUserCircle = (p) => (
  <S {...p}>
    <circle cx="12" cy="12" r="9.5"/>
    <circle cx="12" cy="9"  r="3.5"/>
    <path d="M5 20.5a8.1 8.1 0 0 1 14 0"/>
  </S>
);

// fas fa-user-cog — persona con engrane
export const IcUserCog = (p) => (
  <S {...p}>
    <circle cx="10" cy="7" r="4"/>
    <path d="M3 21v-1a7 7 0 0 1 7-7h1.5"/>
    <circle cx="19" cy="17" r="3.5"/>
    <line x1="19" y1="13" x2="19" y2="14"/>
    <line x1="19" y1="20" x2="19" y2="21"/>
    <line x1="15.5" y1="17" x2="14.5" y2="17"/>
    <line x1="22.5" y1="17" x2="23.5" y2="17"/>
    <line x1="16.4" y1="14.4" x2="15.7" y2="13.7"/>
    <line x1="21.6" y1="19.6" x2="22.3" y2="20.3"/>
    <line x1="21.6" y1="14.4" x2="22.3" y2="13.7"/>
    <line x1="16.4" y1="19.6" x2="15.7" y2="20.3"/>
  </S>
);

// fas fa-user-plus
export const IcUserPlus = (p) => (
  <S {...p}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="8.5" cy="7" r="4"/>
    <line x1="20" y1="8"  x2="20" y2="14"/>
    <line x1="17" y1="11" x2="23" y2="11"/>
  </S>
);

// fas fa-user-edit
export const IcUserEdit = (p) => (
  <S {...p}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="8.5" cy="7" r="4"/>
    <path d="M17.5 10.5l3 3-5.5 5.5H12v-3z"/>
  </S>
);

// fas fa-user-check
export const IcUserCheck = (p) => (
  <S {...p}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="8.5" cy="7" r="4"/>
    <polyline points="17 11 19 13 23 9"/>
  </S>
);

// fas fa-user-slash
export const IcUserSlash = (p) => (
  <S {...p}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="8.5" cy="7" r="4"/>
    <line x1="15" y1="8" x2="22" y2="15"/>
    <line x1="22" y1="8" x2="15" y2="15"/>
  </S>
);

// fas fa-user-tie — persona con corbata
export const IcUserTie = (p) => (
  <S {...p}>
    <circle cx="12" cy="7" r="4"/>
    <path d="M5 22v-1a7 7 0 0 1 7-7h0a7 7 0 0 1 7 7v1"/>
    <polyline points="10.5 14 12 16 13.5 14"/>
    <line x1="12" y1="16" x2="12" y2="20"/>
  </S>
);

// fas fa-users-cog — grupo con engrane
export const IcUsersCog = (p) => (
  <S {...p}>
    <circle cx="8" cy="7" r="3.5"/>
    <path d="M1 21v-1a6.5 6.5 0 0 1 6.5-6.5h1"/>
    <circle cx="18" cy="8" r="2.5" strokeOpacity={0.5}/>
    <path d="M15 13.5A5.5 5.5 0 0 1 21 19.5V21" strokeOpacity={0.5}/>
    <circle cx="19" cy="19" r="3" strokeWidth="1.4"/>
    <line x1="19" y1="16" x2="19" y2="16.5"/>
    <line x1="19" y1="21.5" x2="19" y2="22"/>
    <line x1="16" y1="19" x2="16.5" y2="19"/>
    <line x1="21.5" y1="19" x2="22" y2="19"/>
  </S>
);

// fas fa-lock — candado moderno
export const IcLock = (p) => (
  <S {...p}>
    <rect x="5" y="11" width="14" height="11" rx="2"/>
    <path d="M8 11V7a4 4 0 0 1 8 0v4"/>
    <circle cx="12" cy="16" r="1.5" fill="currentColor" strokeWidth="0"/>
    <line x1="12" y1="17.5" x2="12" y2="19.5"/>
  </S>
);

// fas fa-sign-out-alt — puerta con flecha saliendo
export const IcSignOut = (p) => (
  <S {...p}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16 17 21 12 16 7"/>
    <line x1="21" y1="12" x2="9" y2="12"/>
  </S>
);

// fas fa-key
export const IcKey = (p) => (
  <S {...p}>
    <circle cx="7.5" cy="15.5" r="4.5"/>
    <path d="M10.8 12.2L21 2"/>
    <path d="M18 5l3 3"/>
    <path d="M15 8l3 3"/>
  </S>
);

// fas fa-shield-alt
export const IcShield = (p) => (
  <S {...p}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    <polyline points="9 12 11 14 15 10"/>
  </S>
);

// ── Finanzas / Dinero ─────────────────────────────────────────────────────────

// fas fa-dollar-sign
export const IcDollar = (p) => (
  <S {...p}>
    <line x1="12" y1="2" x2="12" y2="22"/>
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
  </S>
);

// fas fa-percent
export const IcPercent = (p) => (
  <S {...p}>
    <line x1="19" y1="5" x2="5" y2="19"/>
    <circle cx="6.5" cy="6.5" r="2.5"/>
    <circle cx="17.5" cy="17.5" r="2.5"/>
  </S>
);

// fas fa-wallet — billetera con tarjeta
export const IcWallet = (p) => (
  <S {...p}>
    <path d="M20 8H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2z"/>
    <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v2"/>
    <path d="M22 13h-4a2 2 0 0 0 0 4h4"/>
  </S>
);

// fas fa-hand-holding-usd — billetera con flecha de entrada
export const IcHandHoldingUsd = (p) => (
  <S {...p}>
    <path d="M4 7h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2z"/>
    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
    <circle cx="18" cy="13" r="2" fill="currentColor" strokeWidth="0"/>
    <line x1="12" y1="4" x2="12" y2="1"/>
    <polyline points="10 3 12 1 14 3"/>
  </S>
);

// fas fa-receipt — recibo
export const IcReceipt = (p) => (
  <S {...p}>
    <path d="M4 2h16v15l-4 4H4z"/>
    <line x1="8"  y1="8"  x2="16" y2="8"/>
    <line x1="8"  y1="12" x2="16" y2="12"/>
    <line x1="8"  y1="16" x2="12" y2="16"/>
    <polyline points="16 17 16 21 20 17"/>
  </S>
);

// fas fa-money-bill-wave — billete
export const IcMoneyBill = (p) => (
  <S {...p}>
    <rect x="1" y="6" width="22" height="13" rx="2"/>
    <line x1="1"  y1="10" x2="23" y2="10"/>
    <line x1="1"  y1="15" x2="23" y2="15"/>
    <circle cx="12" cy="12.5" r="1.5" fill="currentColor" strokeWidth="0"/>
  </S>
);

// fas fa-money-check-alt — cheque
export const IcMoneyCheck = (p) => (
  <S {...p}>
    <rect x="2" y="6" width="20" height="14" rx="2"/>
    <line x1="6"  y1="11" x2="10" y2="11"/>
    <line x1="6"  y1="15" x2="8"  y2="15"/>
    <line x1="14" y1="11" x2="18" y2="11"/>
    <line x1="14" y1="15" x2="16" y2="15"/>
  </S>
);

// ── Gráficas / Reportes ───────────────────────────────────────────────────────

// fas fa-chart-bar — barras ascendentes con línea de tendencia
export const IcChartBar = (p) => (
  <S {...p}>
    <line x1="3" y1="21" x2="21" y2="21"/>
    <rect x="4"  y="13" width="4" height="8" rx="1"/>
    <rect x="10" y="8"  width="4" height="13" rx="1"/>
    <rect x="16" y="4"  width="4" height="17" rx="1"/>
    <polyline points="5 10 10 6 15 9 20 3" strokeDasharray="1.5 1.5" strokeOpacity={0.6}/>
  </S>
);

// fas fa-chart-column — barras verticales simples
export const IcChartCol = (p) => (
  <S {...p}>
    <line x1="3" y1="21" x2="21" y2="21"/>
    <rect x="5"  y="14" width="3" height="7" rx="1"/>
    <rect x="10.5" y="9" width="3" height="12" rx="1"/>
    <rect x="16" y="5"  width="3" height="16" rx="1"/>
  </S>
);

// fas fa-chart-line — línea de tendencia
export const IcChartLine = (p) => (
  <S {...p}>
    <line x1="3" y1="21" x2="21" y2="21"/>
    <line x1="3" y1="3"  x2="3"  y2="21"/>
    <polyline points="3 17 8 10 13 14 18 6 21 8"/>
    <circle cx="8"  cy="10" r="1.2" fill="currentColor" strokeWidth="0"/>
    <circle cx="13" cy="14" r="1.2" fill="currentColor" strokeWidth="0"/>
    <circle cx="18" cy="6"  r="1.2" fill="currentColor" strokeWidth="0"/>
  </S>
);

// fas fa-chart-pie — gráfica de pastel
export const IcChartPie = (p) => (
  <S {...p}>
    <path d="M21.21 15.89A10 10 0 1 1 8 2.83"/>
    <path d="M22 12A10 10 0 0 0 12 2v10z"/>
  </S>
);

// ── Calendario ────────────────────────────────────────────────────────────────

// fas fa-calendar-alt — calendario con puntos en días
export const IcCalendar = (p) => (
  <S {...p}>
    <rect x="3" y="4" width="18" height="17" rx="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8"  y1="2" x2="8"  y2="6"/>
    <line x1="3"  y1="10" x2="21" y2="10"/>
    <circle cx="8"  cy="15" r="1" fill="currentColor" strokeWidth="0"/>
    <circle cx="12" cy="15" r="1" fill="currentColor" strokeWidth="0"/>
    <circle cx="16" cy="15" r="1" fill="currentColor" strokeWidth="0"/>
    <circle cx="8"  cy="19" r="1" fill="currentColor" strokeWidth="0"/>
    <circle cx="12" cy="19" r="1" fill="currentColor" strokeWidth="0"/>
  </S>
);

// fas fa-calendar-check — calendario con palomita
export const IcCalendarCheck = (p) => (
  <S {...p}>
    <rect x="3" y="4" width="18" height="17" rx="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8"  y1="2" x2="8"  y2="6"/>
    <line x1="3"  y1="10" x2="21" y2="10"/>
    <polyline points="8 15 10.5 17.5 16 12"/>
  </S>
);

// ── Alertas / Estado ──────────────────────────────────────────────────────────

// fas fa-check-circle / far fa-check-circle
export const IcCheckCircle = (p) => (
  <S {...p}>
    <circle cx="12" cy="12" r="9.5"/>
    <polyline points="8 12 10.5 14.5 16 9"/>
  </S>
);

// far fa-times-circle
export const IcXCircle = (p) => (
  <S {...p}>
    <circle cx="12" cy="12" r="9.5"/>
    <line x1="15" y1="9"  x2="9"  y2="15"/>
    <line x1="9"  y1="9"  x2="15" y2="15"/>
  </S>
);

// fas fa-info-circle
export const IcInfo = (p) => (
  <S {...p}>
    <circle cx="12" cy="12" r="9.5"/>
    <circle cx="12" cy="8.5" r="0.8" fill="currentColor" strokeWidth="0"/>
    <line x1="12" y1="11.5" x2="12" y2="16.5"/>
  </S>
);

// fas fa-question-circle
export const IcQuestion = (p) => (
  <S {...p}>
    <circle cx="12" cy="12" r="9.5"/>
    <path d="M9.5 9.5a3 3 0 0 1 5.5 1c0 2-2.5 2.5-2.5 4"/>
    <circle cx="12" cy="17" r="0.8" fill="currentColor" strokeWidth="0"/>
  </S>
);

// fas fa-exclamation-circle
export const IcExclamation = (p) => (
  <S {...p}>
    <circle cx="12" cy="12" r="9.5"/>
    <line x1="12" y1="8"  x2="12" y2="13"/>
    <circle cx="12" cy="16.5" r="0.8" fill="currentColor" strokeWidth="0"/>
  </S>
);

// fas fa-exclamation-triangle
export const IcExclamationTri = (p) => (
  <S {...p}>
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9"  x2="12" y2="13"/>
    <circle cx="12" cy="16.5" r="0.8" fill="currentColor" strokeWidth="0"/>
  </S>
);

// fas fa-pause-circle
export const IcPauseCircle = (p) => (
  <S {...p}>
    <circle cx="12" cy="12" r="9.5"/>
    <line x1="10" y1="9" x2="10" y2="15"/>
    <line x1="14" y1="9" x2="14" y2="15"/>
  </S>
);

// ── Etiquetas / Tags ──────────────────────────────────────────────────────────

// fas fa-tag
export const IcTag = (p) => (
  <S {...p}>
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
    <circle cx="7" cy="7" r="1.3" fill="currentColor" strokeWidth="0"/>
  </S>
);

// fas fa-tags — dos etiquetas
export const IcTags = (p) => (
  <S {...p}>
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
    <circle cx="7" cy="7" r="1.2" fill="currentColor" strokeWidth="0"/>
    <path d="M13 2h2.5L22 8.5v2" strokeOpacity={0.5}/>
  </S>
);

// ── Listas / Organización ─────────────────────────────────────────────────────

// fas fa-list
export const IcList = (p) => (
  <S {...p}>
    <line x1="8"  y1="6"  x2="21" y2="6"/>
    <line x1="8"  y1="12" x2="21" y2="12"/>
    <line x1="8"  y1="18" x2="21" y2="18"/>
    <circle cx="3.5" cy="6"  r="1" fill="currentColor" strokeWidth="0"/>
    <circle cx="3.5" cy="12" r="1" fill="currentColor" strokeWidth="0"/>
    <circle cx="3.5" cy="18" r="1" fill="currentColor" strokeWidth="0"/>
  </S>
);

// fas fa-list-alt — lista con borde
export const IcListAlt = (p) => (
  <S {...p}>
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <line x1="7" y1="8"  x2="17" y2="8"/>
    <line x1="7" y1="12" x2="17" y2="12"/>
    <line x1="7" y1="16" x2="12" y2="16"/>
  </S>
);

// fas fa-clipboard-list — portapapeles con lista
export const IcClipboard = (p) => (
  <S {...p}>
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
    <rect x="8" y="2" width="8" height="4" rx="1"/>
    <circle cx="9" cy="11"   r="1" fill="currentColor" strokeWidth="0"/>
    <line  x1="12" y1="11"   x2="17" y2="11"/>
    <circle cx="9" cy="15.5" r="1" fill="currentColor" strokeWidth="0"/>
    <line  x1="12" y1="15.5" x2="17" y2="15.5"/>
    <circle cx="9" cy="20"   r="1" fill="currentColor" strokeWidth="0" strokeOpacity={0.4}/>
    <line  x1="12" y1="20"   x2="15" y2="20" strokeOpacity={0.4}/>
  </S>
);

// fas fa-layer-group — capas
export const IcLayers = (p) => (
  <S {...p}>
    <polygon points="12 2 2 7 12 12 22 7 12 2"/>
    <polyline points="2 17 12 22 22 17"/>
    <polyline points="2 12 12 17 22 12"/>
  </S>
);

// fas fa-poll — encuesta con barras horizontales
export const IcPoll = (p) => (
  <S {...p}>
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <line x1="7" y1="9"  x2="17" y2="9"/>
    <line x1="7" y1="13" x2="13" y2="13"/>
    <line x1="7" y1="17" x2="15" y2="17"/>
  </S>
);

// fas fa-cog — engrane
export const IcCog = (p) => (
  <S {...p}>
    <circle cx="12" cy="12" r="3.5"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </S>
);

// ── Lugares / Contacto ────────────────────────────────────────────────────────

// fas fa-home
export const IcHome = (p) => (
  <S {...p}>
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </S>
);

// fas fa-building
export const IcBuilding = (p) => (
  <S {...p}>
    <rect x="3" y="2" width="9" height="20"/>
    <rect x="12" y="8" width="9" height="14"/>
    <line x1="3" y1="22" x2="21" y2="22"/>
    <line x1="6" y1="6"  x2="8"  y2="6"/>
    <line x1="6" y1="10" x2="8"  y2="10"/>
    <line x1="6" y1="14" x2="8"  y2="14"/>
    <line x1="6" y1="18" x2="8"  y2="18"/>
    <line x1="15" y1="12" x2="17" y2="12"/>
    <line x1="15" y1="16" x2="17" y2="16"/>
  </S>
);

// fas fa-university — banco/institución
export const IcUniversity = (p) => (
  <S {...p}>
    <line x1="2"  y1="22" x2="22" y2="22"/>
    <rect x="3"  y="10" width="18" height="12"/>
    <polyline points="12 3 22 10 2 10"/>
    <line x1="7"  y1="10" x2="7"  y2="22"/>
    <line x1="12" y1="10" x2="12" y2="22"/>
    <line x1="17" y1="10" x2="17" y2="22"/>
  </S>
);

// fas fa-map-marker-alt — pin de mapa
export const IcMap = (p) => (
  <S {...p}>
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </S>
);

// fas fa-id-card — tarjeta de identificación
export const IcIdCard = (p) => (
  <S {...p}>
    <rect x="2"  y="5" width="20" height="15" rx="2"/>
    <circle cx="8.5" cy="12" r="2.5"/>
    <line x1="14" y1="10" x2="19" y2="10"/>
    <line x1="14" y1="13" x2="19" y2="13"/>
    <line x1="14" y1="16" x2="17" y2="16"/>
  </S>
);

// fas fa-at — arroba / email
export const IcAt = (p) => (
  <S {...p}>
    <circle cx="12" cy="12" r="4"/>
    <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"/>
  </S>
);

// fa-envelope
export const IcEnvelope = (p) => (
  <S {...p}>
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22 6 12 13 2 6"/>
  </S>
);

// fa-phone
export const IcPhone = (p) => (
  <S {...p}>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.64 12 19.79 19.79 0 0 1 1.58 3.49 2 2 0 0 1 3.55 1.32h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.84a16 16 0 0 0 6.29 6.29l.88-.88a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
  </S>
);

// fab fa-whatsapp — W estilizada
export const IcWhatsapp = (p) => (
  <S {...p}>
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
    <path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0v1zm0 0a5 5 0 0 0 5 5m0 0h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1z"/>
  </S>
);

// ── Misceláneos ───────────────────────────────────────────────────────────────

// fas fa-calculator
export const IcCalc = (p) => (
  <S {...p}>
    <rect x="4" y="3" width="16" height="18" rx="2"/>
    <line x1="7" y1="7" x2="17" y2="7"/>
    <circle cx="9"  cy="11" r="1" fill="currentColor" strokeWidth="0"/>
    <circle cx="12" cy="11" r="1" fill="currentColor" strokeWidth="0"/>
    <circle cx="15" cy="11" r="1" fill="currentColor" strokeWidth="0"/>
    <circle cx="9"  cy="15" r="1" fill="currentColor" strokeWidth="0"/>
    <circle cx="12" cy="15" r="1" fill="currentColor" strokeWidth="0"/>
    <circle cx="15" cy="15" r="1" fill="currentColor" strokeWidth="0"/>
    <circle cx="9"  cy="19" r="1" fill="currentColor" strokeWidth="0"/>
    <circle cx="12" cy="19" r="1" fill="currentColor" strokeWidth="0"/>
    <rect   x="13.5" y="17.5" width="3" height="3" rx="0.5" fill="currentColor" strokeWidth="0"/>
  </S>
);

// fas fa-history — reloj con flecha girando
export const IcHistory = (p) => (
  <S {...p}>
    <polyline points="1 4 1 10 7 10"/>
    <path d="M3.51 15a9 9 0 1 0 .49-4.5"/>
    <polyline points="12 7 12 12 15 14"/>
  </S>
);

// fas fa-hourglass-half — reloj de arena
export const IcHourglass = (p) => (
  <S {...p}>
    <path d="M5 3h14"/>
    <path d="M5 21h14"/>
    <path d="M5 3c0 7 7 9 7 9s7-2 7-9"/>
    <path d="M5 21c0-7 7-9 7-9s7 2 7 9"/>
  </S>
);

// fas fa-paper-plane — avión de papel
export const IcPaperPlane = (p) => (
  <S {...p}>
    <line x1="22" y1="2" x2="11" y2="13"/>
    <polygon points="22 2 15 22 11 13 2 9 22 2"/>
  </S>
);

// fas fa-robot
export const IcRobot = (p) => (
  <S {...p}>
    <rect x="3" y="9" width="18" height="12" rx="2"/>
    <path d="M9 3h6"/>
    <line x1="12" y1="3" x2="12" y2="9"/>
    <circle cx="9"  cy="13" r="1.5" fill="currentColor" strokeWidth="0"/>
    <circle cx="15" cy="13" r="1.5" fill="currentColor" strokeWidth="0"/>
    <line x1="9"  y1="17" x2="15" y2="17"/>
    <line x1="1"  y1="12" x2="3"  y2="12"/>
    <line x1="21" y1="12" x2="23" y2="12"/>
  </S>
);

// fas fa-ticket-alt — boleto con perforación
export const IcTicket = (p) => (
  <S {...p}>
    <path d="M2 9V7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4z"/>
    <line x1="9" y1="3" x2="9" y2="21" strokeDasharray="2 2" strokeOpacity={0.5}/>
  </S>
);

// fas fa-trophy — trofeo
export const IcTrophy = (p) => (
  <S {...p}>
    <path d="M6 9V4h12v5a6 6 0 0 1-12 0z"/>
    <path d="M6 9H3l1.5 3L6 11"/>
    <path d="M18 9h3l-1.5 3-1.5-2"/>
    <line x1="12" y1="15" x2="12" y2="19"/>
    <rect x="8" y="19" width="8" height="2" rx="1"/>
  </S>
);

// fas fa-handshake — acuerdo/alianza (dos personas conectadas)
export const IcHandshake = (p) => (
  <S {...p}>
    <circle cx="6"  cy="8" r="3"/>
    <circle cx="18" cy="8" r="3"/>
    <path d="M3 21v-2a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v2"/>
    <line x1="9" y1="14" x2="15" y2="14"/>
    <circle cx="12" cy="14" r="1.2" fill="currentColor" strokeWidth="0"/>
  </S>
);

// fas fa-puzzle-piece
export const IcPuzzle = (p) => (
  <S {...p}>
    <path d="M20.54 15.54a1.5 1.5 0 0 0 0-3 .5.5 0 0 1-.54-.5V7a1 1 0 0 0-1-1h-5.04a.5.5 0 0 1-.5-.54 1.5 1.5 0 0 0-3 0 .5.5 0 0 1-.5.54H5a1 1 0 0 0-1 1v5a.5.5 0 0 1-.54.5 1.5 1.5 0 0 0 0 3 .5.5 0 0 1 .54.5V22h16v-5.96a.5.5 0 0 1 .54-.5z"/>
  </S>
);

// fas fa-chart-area — área bajo la curva
export const IcChartArea = (p) => (
  <S {...p}>
    <line x1="3" y1="3"  x2="3"  y2="21"/>
    <line x1="3" y1="21" x2="21" y2="21"/>
    <path d="M5 16l4-5 4 3 5-7v9z" fill="currentColor" fillOpacity={0.18} strokeWidth="1.3"/>
  </S>
);

// fas fa-balance-scale — balanza
export const IcBalance = (p) => (
  <S {...p}>
    <line x1="12" y1="3" x2="12" y2="21"/>
    <line x1="7" y1="21" x2="17" y2="21"/>
    <line x1="4" y1="6" x2="20" y2="6"/>
    <circle cx="12" cy="4" r="1.3" fill="currentColor" strokeWidth="0"/>
    <path d="M4 6l-2.5 6a2.5 2.5 0 0 0 5 0z"/>
    <path d="M20 6l-2.5 6a2.5 2.5 0 0 0 5 0z"/>
  </S>
);

// fas fa-arrow-trend-up — tendencia al alza
export const IcTrendUp = (p) => (
  <S {...p}>
    <polyline points="2 18 9 11 13 15 22 6"/>
    <polyline points="16 6 22 6 22 12"/>
  </S>
);

// fas fa-arrow-trend-down — tendencia a la baja
export const IcTrendDown = (p) => (
  <S {...p}>
    <polyline points="2 6 9 13 13 9 22 18"/>
    <polyline points="16 18 22 18 22 12"/>
  </S>
);

// fas fa-cubes — cubos / inventario
export const IcCubes = (p) => (
  <S {...p}>
    <path d="M12 2l4 2.5v5L12 12 8 9.5v-5z"/>
    <path d="M5 11.5l4 2.5v5L5 21.5 1 19v-5z"/>
    <path d="M19 11.5l4 2.5v5L19 21.5 15 19v-5z"/>
  </S>
);

// fas fa-comment-dots — burbuja de chat
export const IcComment = (p) => (
  <S {...p}>
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
    <circle cx="8.5"  cy="12" r="1" fill="currentColor" strokeWidth="0"/>
    <circle cx="12"   cy="12" r="1" fill="currentColor" strokeWidth="0"/>
    <circle cx="15.5" cy="12" r="1" fill="currentColor" strokeWidth="0"/>
  </S>
);

// fas fa-city — ciudad / edificios
export const IcCity = (p) => (
  <S {...p}>
    <line x1="1" y1="22" x2="23" y2="22"/>
    <path d="M4 22V8l5-3v17"/>
    <path d="M9 22V11l6-3v14"/>
    <path d="M15 22V13l5-2v11"/>
    <line x1="6.5" y1="11" x2="6.5" y2="11.5"/>
    <line x1="12" y1="14" x2="12" y2="14.5"/>
    <line x1="17.5" y1="16" x2="17.5" y2="16.5"/>
  </S>
);

// far fa-newspaper — periódico
export const IcNewspaper = (p) => (
  <S {...p}>
    <path d="M4 4h13a1 1 0 0 1 1 1v14a1 1 0 0 0 1 1 1 1 0 0 0 1-1V8h-3"/>
    <path d="M4 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h15"/>
    <line x1="7" y1="8"  x2="14" y2="8"/>
    <line x1="7" y1="12" x2="14" y2="12"/>
    <line x1="7" y1="16" x2="11" y2="16"/>
  </S>
);

// ── Iconos de marca / redes sociales ──────────────────────────────────────────

// fab fa-facebook
export const IcFacebook = (p) => (
  <S {...p}>
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
  </S>
);

// fab fa-twitter
export const IcTwitter = (p) => (
  <S {...p}>
    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/>
  </S>
);

// fab fa-instagram
export const IcInstagram = (p) => (
  <S {...p}>
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
  </S>
);

// fab fa-linkedin
export const IcLinkedin = (p) => (
  <S {...p}>
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
    <rect x="2" y="9" width="4" height="12"/>
    <circle cx="4" cy="4" r="2"/>
  </S>
);

// ── Helper central: renderiza un icono FA por su clase string ─────────────────
// Permite que los arrays de datos conserven `icon: "fas fa-x"` y se rendericen
// como SVG con <FaIcon cls={item.icon} />, sin tener que convertir cada array.
const FA_MAP = {
  "fas fa-plus": IcPlus, "fas fa-plus-circle": IcPlusCircle, "fas fa-minus": IcMinus,
  "fas fa-times": IcX, "fas fa-ban": IcBan, "fas fa-save": IcSave,
  "fas fa-edit": IcEdit, "far fa-edit": IcEdit, "fas fa-trash-alt": IcTrash,
  "fas fa-search": IcSearch, "fas fa-bars": IcMenu, "fas fa-sort": IcSort,
  "far fa-file-pdf": IcPdf, "far fa-file-excel": IcExcel, "fas fa-table": IcTable,
  "fas fa-check-circle": IcCheckCircle, "far fa-check-circle": IcCheckCircle,
  "far fa-times-circle": IcXCircle, "fas fa-info-circle": IcInfo,
  "fas fa-question-circle": IcQuestion, "fas fa-exclamation-circle": IcExclamation,
  "fas fa-exclamation-triangle": IcExclamationTri, "fas fa-pause-circle": IcPauseCircle,
  "fas fa-sync-alt": IcSync, "fas fa-repeat": IcRepeat, "fas fa-exchange-alt": IcExchange,
  "fas fa-dollar-sign": IcDollar, "fas fa-percent": IcPercent, "fas fa-wallet": IcWallet,
  "fas fa-receipt": IcReceipt, "fas fa-money-bill-wave": IcMoneyBill,
  "fas fa-money-check-alt": IcMoneyCheck, "fas fa-hand-holding-usd": IcHandHoldingUsd,
  "fas fa-file-alt": IcFileAlt, "fas fa-file-invoice": IcFileInvoice,
  "fas fa-file-invoice-dollar": IcFileInvoiceDollar,
  "fas fa-chart-bar": IcChartBar, "fas fa-chart-line": IcChartLine,
  "fas fa-chart-pie": IcChartPie, "fas fa-chart-column": IcChartCol,
  "fas fa-chart-area": IcChartArea, "fas fa-balance-scale": IcBalance,
  "fas fa-arrow-trend-up": IcTrendUp, "fas fa-arrow-trend-down": IcTrendDown,
  "fas fa-arrow-up": IcArrowUp, "fas fa-arrow-down": IcArrowDown,
  "fas fa-arrow-left": IcArrowLeft, "fas fa-arrow-right": IcArrowRight,
  "fas fa-calendar-alt": IcCalendar, "fas fa-calendar": IcCalendar,
  "fas fa-calendar-check": IcCalendarCheck,
  "fas fa-users": IcUsers, "fas fa-user-plus": IcUserPlus, "fas fa-user-edit": IcUserEdit,
  "fas fa-user-check": IcUserCheck, "fas fa-user-slash": IcUserSlash,
  "fas fa-user-tie": IcUserTie, "fas fa-users-cog": IcUsersCog, "fas fa-user-cog": IcUserCog,
  "fas fa-user-circle": IcUserCircle, "fas fa-lock": IcLock, "fas fa-sign-out-alt": IcSignOut,
  "fas fa-key": IcKey, "fas fa-shield-alt": IcShield, "fas fa-home": IcHome,
  "fas fa-building": IcBuilding, "fas fa-university": IcUniversity, "fas fa-city": IcCity,
  "fas fa-map-marker-alt": IcMap, "fas fa-id-card": IcIdCard, "fas fa-at": IcAt,
  "fa fa-envelope": IcEnvelope, "fa fa-phone": IcPhone, "fab fa-whatsapp": IcWhatsapp,
  "fas fa-calculator": IcCalc, "fas fa-history": IcHistory, "fas fa-hourglass-half": IcHourglass,
  "fas fa-spinner": IcSpinner, "fas fa-paper-plane": IcPaperPlane, "fas fa-robot": IcRobot,
  "fas fa-ticket-alt": IcTicket, "fas fa-trophy": IcTrophy, "fas fa-handshake": IcHandshake,
  "fas fa-puzzle-piece": IcPuzzle, "fas fa-cog": IcCog, "fas fa-tag": IcTag, "fas fa-tags": IcTags,
  "fas fa-layer-group": IcLayers, "fas fa-poll": IcPoll, "fas fa-list": IcList,
  "fas fa-list-alt": IcListAlt, "fas fa-clipboard-list": IcClipboard,
  "fas fa-cubes": IcCubes, "fas fa-comment-dots": IcComment, "far fa-newspaper": IcNewspaper,
};

// Renderiza el SVG correspondiente a una clase FA. Si no hay match, no rompe (null).
export const FaIcon = ({ cls, size, style, className }) => {
  const Cmp = FA_MAP[cls];
  if (!Cmp) return null;
  return <Cmp size={size} style={style} className={className} />;
};
